import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DatePeriodValidation } from '@validators/date-period-validation';
import { DateValidation } from '@validators/date.validation';
import moment from 'moment';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  public isExpanded = false;
  public defaultFilterValue = {
    openedAtGte: moment().subtract(1, 'month'),
    openedAtLte: moment(),
    locations: null,
    maintenanceTypes: null,
    segments: null,
    companies: null,
    locationGroups: null,
    scheduledAtGte: null,
    scheduledAtLte: null,
    closedAtGte: null,
    closedAtLte: null,
  };
  public filterForm = new FormGroup({
    openedAtGte: new FormControl(this.defaultFilterValue.openedAtGte, [Validators.required, DateValidation.validate]),
    openedAtLte: new FormControl(this.defaultFilterValue.openedAtLte, [Validators.required, DateValidation.validate]),
    locations: new FormControl(this.defaultFilterValue.locations),
    maintenanceTypes: new FormControl(this.defaultFilterValue.maintenanceTypes),
    segments: new FormControl(this.defaultFilterValue.segments),
    companies: new FormControl(this.defaultFilterValue.companies),
    locationGroups: new FormControl(this.defaultFilterValue.locationGroups),
    scheduledAtGte: new FormControl(this.defaultFilterValue.scheduledAtGte, DateValidation.validate),
    scheduledAtLte: new FormControl(this.defaultFilterValue.scheduledAtLte, DateValidation.validate),
    closedAtGte: new FormControl(this.defaultFilterValue.closedAtGte, DateValidation.validate),
    closedAtLte: new FormControl(this.defaultFilterValue.closedAtLte, DateValidation.validate)
  }, {
    validators: [
      DateIntervalValidation.validate({
        from: 'openedAtGte',
        to: 'openedAtLte',
        maxDiffLte: 1,
        unit: 'year'
      }),
      DatePeriodValidation.validate(['openedAt', 'closedAt', 'scheduledAt'])
    ]
  });

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
}
